export default __webpack_public_path__ + "b2786220db48a960d3133f3ab872f07a.svg";